import { FormFieldTypes } from "../../../data/formFieldType";

export const EditCommitteeApproval = {
    name: "editCommitteeApproval.Data",
    initialState: {
        name: ''
    },
    formFields: [
        {
            id: "comments",
            lable: "Comments :",
            Field_Name: "Comments",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "comments",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-12",
            },
        },

    ],
    formSetting: {
        isViewOnly: false
    }
}
